import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Famille } from '@/types';

interface FamilleState {
  familles: Famille[];
}

const initialState: FamilleState = { familles: [] };

const familleSlice = createSlice({
  name: 'famille',
  initialState,
  reducers: {
    setFamilles(state, action: PayloadAction<Famille[]>) {
      state.familles = action.payload;
    },
    addFamille(state, action: PayloadAction<Famille>) {
      state.familles.push(action.payload);
    },
    removeFamille(state, action: PayloadAction<Famille>) {
      state.familles = state.familles.filter((f) => f.id !== action.payload.id);
    },
    editFamille(state, action: PayloadAction<Famille>) {
      const i = state.familles.findIndex((f) => f.id === action.payload.id);
      if (i !== -1) state.familles[i] = action.payload;
    },
  },
});

export const { setFamilles, addFamille, removeFamille, editFamille } = familleSlice.actions;
export default familleSlice.reducer;
